export const LESSION_MODES = [
  {
    text: 'Live Streaming',
    value: 'Live Streaming',
  },
  {
    text: 'Live Streaming o in aula a Milano',
    value: 'Live Streaming/Milano',
  },
  {
    text: 'Live Streaming o in aula a Roma',
    value: 'Live Streaming/Roma',
  },
  {
    text: ' Live Streaming o in aula a Milano e a Roma',
    value: 'Live Streaming/Milano e Roma',
  },
  {
    text: 'On Demand',
    value: 'On Demand',
  },
  {
    text: 'Live Streaming + On Demand',
    value: 'Live Streaming + On Demand',
  },
  {
    text: 'Always On',
    value: 'Always On',
  },
];

export const STUDENT_TYPES = [
  {
    text: 'Neo Laureati',
    value: 'Neo Laureati',
  },
  {
    text: 'Neo Diplomati',
    value: 'Neo Diplomati',
  },
  {
    text: 'Professionisti',
    value: 'Professionisti',
  },
  {
    text: 'Executive',
    value: 'Executive',
  },
];
